export default "__VITE_ASSET__DMFrN6qd__"